import { RemixBrowser } from '@remix-run/react';
import { startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import logger from './services/logger';

function hydrate() {
  startTransition(() => {
    hydrateRoot(document, <RemixBrowser />);
  });
}

function scheduleHydration() {
  if (window.requestIdleCallback) {
    window.requestIdleCallback(hydrate);
  } else {
    // Safari doesn't support requestIdleCallback
    // https://caniuse.com/requestidlecallback
    window.setTimeout(hydrate, 1);
  }
}

if (window.isMock) {
  (async () => {
    const { prepare } = await import('./mocks/prepare-sw.client');

    prepare()
      .then(() => scheduleHydration())
      .catch((err: any) => {
        logger.info(`Failed to prepare app: ${err.message}`);
      });
  })();
} else {
  scheduleHydration();
}
